var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentPage === 2)?_c('div',[_c('InformacaoPreparoInox',{attrs:{"model":_vm.model,"isBusy":_vm.isBusy}}),_c('LeituraMateriais',{attrs:{"model":_vm.model,"isBusy":_vm.isBusy}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }